import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';

import './help_styles/helpstack.css';

export default function HelpStack() {
  return (
    <>
      <Container className='help_stack'>
        <Row className='mb-2 help_stack_row'>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
        </Row>
        <Row className='mb-2 help_stack_row'>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
        </Row>
        <Row className='mb-2 help_stack_row'>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
        </Row>
        <Row className='help_stack_row'>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
            <Col lg={3} md={6} className='mt-3'>
              <Button className='w-100'>Loream ipsum</Button>
            </Col>
        </Row>
        <div>
          <Button className='w-100 mt-3 mb-5 helpstack_btn'>VirtualEx</Button>
        </div>
      </Container>
    </>
  )
}
